import styled from "styled-components";

const Skeleton = (props) => {
  // console.log("props: ", props);
  return (
    <>
      <Wrapper>
        <div className={props.loading ? "sk-container" : "sk-container d-none"}>
          <div className="d-flex justify-content-between align-items-baseline">
            <span className="skeleton-box" style={{ width: "15%", height: "2em" }}></span>
            <span className="skeleton-box" style={{ width: "25%" }}></span>
          </div>
          <br />
          <div className="d-flex">
            <span className="skeleton-box" style={{ width: "60%", height: "1.2em" }}></span>
          </div>
          <br />
          <div className="d-flex flex-column">
            <span className="skeleton-box mb-1" style={{ width: "25%" }}></span>
            <span className="skeleton-box mb-1" style={{ width: "28%" }}></span>
            <span className="skeleton-box mb-1" style={{ width: "20%" }}></span>
          </div>
          <br />
          <div className="d-flex align-items-end">
            <span className="skeleton-box" style={{ width: "15%", minWidth: "75px", height: "5.5em", marginRight: "15px" }}></span>
            <div className="d-flex flex-column w-100">
              <span className="skeleton-box mb-1" style={{ width: "15%" }}></span>
              <span className="skeleton-box mb-1" style={{ width: "17%" }}></span>
              <span className="skeleton-box mb-1" style={{ width: "18%" }}></span>
              <span className="skeleton-box mb-1" style={{ width: "22%" }}></span>
            </div>
          </div>
          <br />
          <div className="d-flex flex-column">
            <span className="skeleton-box mb-1 w-100" style={{ height: "20em" }}></span>
            <span className="skeleton-box mb-2 w-100" style={{ height: "1.1em" }}></span>
            <span className="skeleton-box mb-1 w-100"></span>
            <span className="skeleton-box mb-1 w-100"></span>
            <span className="skeleton-box mb-1 w-100"></span>
            <span className="skeleton-box mb-1 w-100"></span>
            <span className="skeleton-box mb-1 w-100"></span>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default Skeleton;

const Wrapper = styled.div`
  overflow: hidden;
  @-webkit-keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }

  @keyframes shimmer {
    100% {
      -webkit-transform: translateX(100%);
      transform: translateX(100%);
    }
  }
  .sk-container {
    width: 600px;
    background-color: #ffffff;
    padding: 20px;
    margin: 70px auto 0;
    .skeleton-box {
      display: inline-block;
      height: 1em;
      position: relative;
      overflow: hidden;
      background-color: #dddbdd;
      &:after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        -webkit-transform: translateX(-100%);
        transform: translateX(-100%);
        background-image: -webkit-gradient(
          linear,
          left top,
          right top,
          color-stop(0, rgba(255, 255, 255, 0)),
          color-stop(20%, rgba(255, 255, 255, 0.2)),
          color-stop(60%, rgba(255, 255, 255, 0.5)),
          to(rgba(255, 255, 255, 0))
        );
        background-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0,
          rgba(255, 255, 255, 0.2) 20%,
          rgba(255, 255, 255, 0.5) 60%,
          rgba(255, 255, 255, 0)
        );
        -webkit-animation: shimmer 2s infinite;
        animation: shimmer 2s infinite;
        content: "";
      }
    }
  }
`;
